import * as t from 'io-ts'
import { Attachment } from '@espoon-voltti/org-ts-api'

export const AttachmentDto = Attachment
export type AttachmentDto = t.TypeOf<typeof AttachmentDto>
